// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.light input:-webkit-autofill,
.light input:-webkit-autofill:hover,
.light input:-webkit-autofill:focus,
.light input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus,
.dark input:-webkit-autofill:active {
    background-color: black !important;
    -webkit-box-shadow: 0 0 0 30px #20466c inset !important;
    -webkit-text-fill-color: white !important;
}

::-webkit-scrollbar {
    width: 7px;
    height: 5px;
}

.dark ::-webkit-scrollbar-track {
    /* border-radius: 100vh; */
    background: #3a4350;
}

::-webkit-scrollbar-track {
    /* border-radius: 100vh; */
    background: #fff;
}

.dark ::-webkit-scrollbar-thumb {
    background: #797979;
    border-radius: 100vh;
}

::-webkit-scrollbar-thumb {
    background: #7d889f;
    border-radius: 100vh;
}

::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4;
    cursor: pointer;
}

.sidebar-scrollbar-fancy {
    scrollbar-color: rgba(37, 99, 235, 0.55) transparent;
    scrollbar-width: thin;
}

.sidebar-scrollbar-fancy::-webkit-scrollbar {
    width: 5px;
}

.sidebar-scrollbar-fancy::-webkit-scrollbar-track {
    background: linear-gradient(180deg, transparent, rgba(148, 163, 184, 0.08), transparent);
    border-radius: 999px;
}

.sidebar-scrollbar-fancy::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #60a5fa 0%, #2563eb 52%, #7c3aed 100%);
    border-radius: 999px;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45), 0 0 10px rgba(37, 99, 235, 0.35);
}

.sidebar-scrollbar-fancy::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #93c5fd 0%, #3b82f6 48%, #8b5cf6 100%);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55), 0 0 14px rgba(37, 99, 235, 0.55);
}

.dark .sidebar-scrollbar-fancy {
    scrollbar-color: rgba(96, 165, 250, 0.7) transparent;
}

.dark .sidebar-scrollbar-fancy::-webkit-scrollbar-track {
    background: linear-gradient(180deg, transparent, rgba(148, 163, 184, 0.14), transparent);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;;;IAII,qDAAqD;AACzD;;AAEA;;;;IAII,kCAAkC;IAClC,uDAAuD;IACvD,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oDAAoD;IACpD,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wFAAwF;IACxF,oBAAoB;AACxB;;AAEA;IACI,0EAA0E;IAC1E,oBAAoB;IACpB,uFAAuF;AAC3F;;AAEA;IACI,0EAA0E;IAC1E,uFAAuF;AAC3F;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.light input:-webkit-autofill,\n.light input:-webkit-autofill:hover,\n.light input:-webkit-autofill:focus,\n.light input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n.dark input:-webkit-autofill,\n.dark input:-webkit-autofill:hover,\n.dark input:-webkit-autofill:focus,\n.dark input:-webkit-autofill:active {\n    background-color: black !important;\n    -webkit-box-shadow: 0 0 0 30px #20466c inset !important;\n    -webkit-text-fill-color: white !important;\n}\n\n::-webkit-scrollbar {\n    width: 7px;\n    height: 5px;\n}\n\n.dark ::-webkit-scrollbar-track {\n    /* border-radius: 100vh; */\n    background: #3a4350;\n}\n\n::-webkit-scrollbar-track {\n    /* border-radius: 100vh; */\n    background: #fff;\n}\n\n.dark ::-webkit-scrollbar-thumb {\n    background: #797979;\n    border-radius: 100vh;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #7d889f;\n    border-radius: 100vh;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #c4c4c4;\n    cursor: pointer;\n}\n\n.sidebar-scrollbar-fancy {\n    scrollbar-color: rgba(37, 99, 235, 0.55) transparent;\n    scrollbar-width: thin;\n}\n\n.sidebar-scrollbar-fancy::-webkit-scrollbar {\n    width: 5px;\n}\n\n.sidebar-scrollbar-fancy::-webkit-scrollbar-track {\n    background: linear-gradient(180deg, transparent, rgba(148, 163, 184, 0.08), transparent);\n    border-radius: 999px;\n}\n\n.sidebar-scrollbar-fancy::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #60a5fa 0%, #2563eb 52%, #7c3aed 100%);\n    border-radius: 999px;\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45), 0 0 10px rgba(37, 99, 235, 0.35);\n}\n\n.sidebar-scrollbar-fancy::-webkit-scrollbar-thumb:hover {\n    background: linear-gradient(180deg, #93c5fd 0%, #3b82f6 48%, #8b5cf6 100%);\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55), 0 0 14px rgba(37, 99, 235, 0.55);\n}\n\n.dark .sidebar-scrollbar-fancy {\n    scrollbar-color: rgba(96, 165, 250, 0.7) transparent;\n}\n\n.dark .sidebar-scrollbar-fancy::-webkit-scrollbar-track {\n    background: linear-gradient(180deg, transparent, rgba(148, 163, 184, 0.14), transparent);\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
